export * from "./mapProductToSummaryItem";
